
import Vue from 'vue'
import { MAX_START_SESSION_TIME } from '@/constants/business'

const validate = (value, { time = MAX_START_SESSION_TIME, timeFormat = 'HH:mm:ss' } = {}) => {
  if (Vue.isTestMode()) {
    return true
  }
  if (!value) return false
  const startDate = Vue.prototype.$moment(value)

  const bottomTimeBoundaries = Vue.prototype.$moment(time, timeFormat)
  // время начала сессии не раньше 10:00
  return bottomTimeBoundaries.isSameOrAfter(Vue.prototype.$moment(startDate.format(timeFormat), timeFormat))
}

export default {
  validate
}
